import { Card } from "~/features/configurator/Linear/components/Card";
import classes from "./InformationCard.module.less";
import classNames from "classnames";
import { type ReactNode } from "react";
import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";
import { Collapse, IconButton } from "~/common/mui";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

interface InformationCardProps {
  className?: string;
  children?: ReactNode;
  title: string;
  editAction?: () => void;
  error?: boolean;
}

const InformationCard = ({ title, editAction, error, className, children }: InformationCardProps) => {
  const { val: isOpen, setTrue: openCard, setFalse: closeCard } = useBooleanState(true);

  const isTablet = useIsMinTabletSize();

  return (
    <Card disableHover className={classNames(classes.root, error && classes.error, className)}>
      <div className={classes.header}>
        <h5 className={classes.headerTitle}>{title}</h5>

        {editAction && (
          <IconButton onClick={editAction} color={"primary"}>
            <Icon type={IconType.Pencil} />
          </IconButton>
        )}
        {!isTablet && (
          <IconButton className={classes.button} onClick={isOpen ? closeCard : openCard}>
            <Icon type={isOpen ? IconType.ChevronUp : IconType.ChevronDown} />
          </IconButton>
        )}
      </div>

      <Collapse in={isOpen}>{children}</Collapse>
    </Card>
  );
};

export default InformationCard;
